import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/more.svg'
import _imports_1 from '@/assets/icons/edit.svg'


const _withScopeId = n => (_pushScopeId("data-v-1fe531b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-row items-center justify-between mb-4 mt-4" }
const _hoisted_3 = { class: "flex flex-row items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-400",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Create new role")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "capitalize" }
const _hoisted_8 = ["onMouseenter"]
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = {
  key: 0,
  class: "absolute bg-white p-2 shadow rounded border border-primary z-50"
}
const _hoisted_11 = ["onMouseenter"]
const _hoisted_12 = { class: "capitalize" }
const _hoisted_13 = {
  key: 0,
  class: "absolute bg-white p-2 shadow rounded border border-primary z-50"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 0,
  class: "absolute flex flex-col text-black bg-white right-0 mr-2 mt-4 rounded-2xl shadow hover:shadow-md p-2 w-72 z-50"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Edit")
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6 text-red-500",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Delete")
], -1))
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueTableLite = _resolveComponent("VueTableLite")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("input", {
          placeholder: "Search for a role...",
          type: "text",
          class: "ml-2 focus:outline-none w-full",
          onKeyup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.search($event)))
        }, null, 32)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "space-x-3 btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate text-base bg-primary rounded-full transition duration-150 ease-in",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/add-role?companyId=${_ctx.company_id}`)))
        }, _hoisted_6)
      ])
    ]),
    _createVNode(_component_VueTableLite, {
      "is-loading": _ctx.table.isLoading,
      columns: _ctx.table.columns,
      rows: _ctx.table.rows,
      total: _ctx.table.totalRecordCount,
      sortable: _ctx.table.sortable,
      "is-slot-mode": true,
      "is-hide-paging": true
    }, {
      name: _withCtx((data) => [
        _createElementVNode("div", null, _toDisplayString(data.value.name), 1)
      ]),
      department: _withCtx((data) => [
        _createElementVNode("div", _hoisted_7, _toDisplayString(data.value.department), 1)
      ]),
      benefits: _withCtx((data) => [
        _createElementVNode("div", {
          onMouseenter: ($event: any) => (_ctx.showTooltip = data.value.id),
          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTooltip = ''))
        }, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(data.value.meta.benefits_count), 1),
          (
              _ctx.showTooltip === data.value.id && data.value.benefits.length > 0
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.benefits, (benefit, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(benefit.name) + ": $" + _toDisplayString((benefit.value / 100).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 40, _hoisted_8)
      ]),
      employees: _withCtx((data) => [
        _createElementVNode("div", {
          onMouseenter: ($event: any) => (_ctx.showEmployees = data.value.id),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showEmployees = ''))
        }, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(data.value.meta.users_count), 1),
          (
              _ctx.showEmployees === data.value.id &&
              data.value.meta.users.length > 0
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.meta.users, (emp, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(emp.name), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 40, _hoisted_11)
      ]),
      menu: _withCtx((data) => [
        _createElementVNode("button", {
          onClick: ($event: any) => (_ctx.openDropdown(data.value.id))
        }, _hoisted_16, 8, _hoisted_14),
        (data.value.id === _ctx.dropdownItem)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "hover:bg-background p-4 rounded",
                onClick: ($event: any) => (
              _ctx.$router.push(
                `/add-role?roleId=${data.value.id}&companyId=${_ctx.company_id}`
              )
            )
              }, _hoisted_20, 8, _hoisted_18),
              _createElementVNode("button", {
                class: "hover:bg-background p-4 rounded",
                onClick: ($event: any) => (_ctx.removeRole(data.value.id))
              }, _hoisted_23, 8, _hoisted_21)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-loading", "columns", "rows", "total", "sortable"]),
    _createVNode(_component_Paginator, {
      modelValue: _ctx.page,
      page: _ctx.page,
      pages: _ctx.pagination.total_pages,
      "range-size": 1,
      "onUpdate:modelValue": _ctx.updateHandler,
      total: _ctx.pagination.total_count,
      from: _ctx.pagination.from,
      to: _ctx.pagination.to
    }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
  ]))
}